const DOMAIN = 'fivelunches.com'

/**
 * A harmless flag on .fivelunches.com saying "this browser is signed in to
 * the app", so the marketing site at the apex can skip its pitch and send a
 * returning parent straight to app.fivelunches.com. It carries nothing
 * secret -- the real session cookie stays on the app's own host -- and it
 * only exists on the production domain; local and preview hosts leave it.
 */
export function markSignedIn(on: boolean) {
  const host = location.hostname
  if (host !== DOMAIN && !host.endsWith(`.${DOMAIN}`)) return
  try {
    document.cookie = `fl_app=${on ? '1' : ''}; domain=.${DOMAIN}; path=/; max-age=${on ? 60 * 60 * 24 * 365 : 0}; samesite=lax; secure`
  } catch {
    // Cookies blocked: the apex just shows its page, as it always did.
  }
}
